<div fxLayout>
  <main [ngClass.lt-md]="{ mobile: true }">
    <header>
      <div class="container">
        <h2>Hello {{ user.first_name }}, how can we help you?</h2>
        <sbnb-search-field
          [autofocus]="true"
          [(value)]="search"
          (valueChange)="updateSearchResults()"></sbnb-search-field>
        <div class="shortcuts" *ngIf="!loading && hasResult">
          <sbnb-shortcut-list [shortcuts]="result.shortcuts"></sbnb-shortcut-list>
        </div>
      </div>
      <a class="close" [routerLink]="overlaySimulatorService.getCloseUrl()">
        <sbnb-support-documentation-icon icon="close"></sbnb-support-documentation-icon>
      </a>
    </header>
    <div *ngIf="loading" style="display: flex; justify-content: center; align-items: center">
      <img src="/assets/images/preloader.gif" alt="Loading..." />
    </div>
    <div class="container" *ngIf="!loading && hasResult">
      <section *ngFor="let category of result.categories">
        <sbnb-article-list
          [icon]="category.icon"
          [title]="category.name"
          [articles]="category.articles"
          columns="2"></sbnb-article-list>
      </section>
    </div>
    <div class="container no-result" *ngIf="!loading && !hasResult">
      <p fxLayout fxLayoutGap="12px">
        <span>Nothing found, you can browse our categories or</span>
        <sbnb-button label="ask our support team" size="mini" (click)="talkToSupport(search)"></sbnb-button>
      </p>
      <sbnb-category-card-grid [categories]="result.categories"></sbnb-category-card-grid>
    </div>
  </main>
</div>
